// removed by extract-text-webpack-plugin
module.exports = {"branding":"Branding__branding___2tPUO","logo":"Branding__logo___1Q_Gs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Branding/Branding.scss
// module id = 921
// module chunks = 0